<template>
  <div class="tripBudget">
    <update-budget :budgetList="budgetList" :chenckBudget="checkBudget"></update-budget>
    <budget-detail  :checkBudget="checkBudget" :chooseStockTypes="chooseStockTypes" :showCostPrice="showCostPrice"
      @selectLinkProduct="selectLinkProduct" :allStockTypes="allStockTypes" :planProductShowStatus="planProductShowStatus"></budget-detail>
    <link-product-dialog ref="linkProduct" :checkBudget="checkBudget"></link-product-dialog>
  </div>
</template>

<script>
import budgetDetail from './children/budgetDetail.vue'
import LinkProductDialog from './dialog/linkProductDialog.vue'
import UpdateBudget from './dialog/updateBudget.vue'
export default {
  components: { budgetDetail,LinkProductDialog, UpdateBudget},
  props:{
    checkBudget:{
      type:Object,
      default:()=>{return {}}
    },
    planDetail:{
      type:Object,
      default:()=>{return {}}
    },
    chooseStockTypes:{
      type:Array,
      default:()=>{return []}
    },
    allStockTypes:{
      type:Array,
      default:()=>{return []}
    },
    budgetList:{
      type:Array,
      default:()=>{return []}
    },
    showCostPrice:{
      type:Boolean,
      default:true,
    },
    planProductShowStatus:{
      type:Boolean,
      default:true,
    },
  },
  data(){
    return{
      
    }
  },
  methods:{
    selectLinkProduct(item){
      this.$refs.linkProduct.beforOpen(item)
    },
    //订
  }
}
</script>

<style lang="scss" scoped>
 .clsStatus{
  font-size: 0.12rem;
  color: #000000;
}

</style>